import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { InstanceTagField } from '@/components/forms/RunRiskCalibrationForm/fields/InstanceTagField'
import { ReportsField } from '@/components/forms/RunRiskCalibrationForm/fields/ReportsField'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface CustomRiskFieldsProps {}

export const CustomRiskFields: React.FC<CustomRiskFieldsProps> = ({}) => {
  return (
    <div className={'space-y-6'}>
      <FormFieldRow>
        <ValueDateField />
        <InstanceTagField />
      </FormFieldRow>
      <ReportsField />
    </div>
  )
}
